import { ChevronUp } from "@moneris-portal/svg-components";
import "./index.scss";
import Hook from "./useAccordion";
import classNames from "classnames";

const Accordion = (props) => {
  const { header, body, children } = props;
  const { BLOCK, collapsed, handleToggle } = Hook.useAccordion(props);

  return (
    <div className={BLOCK.current}>
      <h3>
        <button
          id="accordion-button"
          className={`${BLOCK.current}__header`}
          type="button"
          aria-expanded={!collapsed}
          aria-controls="accordion-body"
          onClick={handleToggle}
        >
          <div
            className={classNames(`${BLOCK.current}__icon`, {
              [`${BLOCK.current}__icon--collapsed`]: collapsed,
            })}
          >
            <ChevronUp />
          </div>
          {header}
        </button>
      </h3>
      <div
        id="accordion-body"
        role="region"
        aria-labelledby="accordion-button"
        className={classNames(`${BLOCK.current}__body`, {
          [`${BLOCK.current}__body--collapsed`]: collapsed,
        })}
      >
        {children ? children : <p>{body}</p>}
      </div>
    </div>
  );
};

export default Accordion;

